import { useSubscriptionStore } from '@/stores/subscriptionStore';
import { useAuthStore } from '@/stores/authStore';
import { Capacitor } from '@capacitor/core';

export function BillingIssueBanner() {
  const authMode = useAuthStore((s) => s.authMode);
  const billingIssue = useSubscriptionStore((s) => s.subscription.billingIssue);
  const managementUrl = useSubscriptionStore((s) => s.subscription.managementUrl);

  if (authMode !== 'authenticated' || !billingIssue) return null;

  return (
    <div className="flex items-center justify-between gap-3 border-b border-warn bg-warn-bg px-4 py-2">
      <p className="text-xs text-t1">
        There&apos;s an issue with your payment. Update your payment method to keep Pro.
      </p>
      <button
        onClick={() => {
          const url = Capacitor.isNativePlatform()
            ? 'itms-apps://apps.apple.com/account/subscriptions'
            : managementUrl;
          if (url) window.open(url, '_blank');
        }}
        className="whitespace-nowrap rounded text-xs font-medium text-t1 underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2 focus-visible:ring-offset-canvas"
      >
        Fix payment
      </button>
    </div>
  );
}
